module.exports = __webpack_public_path__ + "static/media/AgileCoach.2f01c8cd.png";